import { type ComponentResolver } from "./ComponentResolver";

export const awsComponentResolver: ComponentResolver = {
  // currentyl no special component in AWS
  resolveStringComponent: () => null,
};
